import { API_TAGS } from '../../constants/api';
import { apiSlice } from '../apiSlice';
import { MESSAGES } from './staticVariablesMessages';

export const staticVariablesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchStaticVariables: builder.query({
      query: ({ orgId, tenantId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/static-variables`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_STATIC_VARIABLES.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [
          { type: API_TAGS.STATIC_VARIABLES, id: 'LIST' }
        ];
      }
    }),
    createStaticVariable: builder.mutation({
      query: ({ orgId, tenantId, data }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/static-variables`,
        method: 'POST',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_STATIC_VARIABLES.ERROR
        },
        successMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_STATIC_VARIABLES.SUCCESS
        }
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        return [
          { type: API_TAGS.STATIC_VARIABLES, id: 'LIST' }
        ];
      }
    }),
    updateStaticVariable: builder.mutation({
      query: ({ orgId, tenantId, data }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/static-variables/`,
        method: 'PATCH',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_STATIC_VARIABLES.ERROR
        },
        successMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_STATIC_VARIABLES.SUCCESS
        }
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        return [
          { type: API_TAGS.STATIC_VARIABLES, id: 'LIST' }
        ];
      }
    }),
    deleteStaticVariable: builder.mutation({
      query: ({ orgId, tenantId, data }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/static-variables/`,
        body: data,
        method: 'DELETE',
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.DELETE_STATIC_VARIABLES.ERROR
        },
        successMessage: {
          showMessage: true,
          messages: MESSAGES.DELETE_STATIC_VARIABLES.SUCCESS
        }
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        return [
          { type: API_TAGS.STATIC_VARIABLES, id: 'LIST' }
        ];
      }
    })
  })
});

export const {
  useFetchStaticVariablesQuery,
  useCreateStaticVariableMutation,
  useUpdateStaticVariableMutation,
  useDeleteStaticVariableMutation
} = staticVariablesSlice;
